import { toast } from "react-toastify";
import { _QualityInspectionItem, _QualityInspectionLoteItem, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { BasicTable, MASK_DATE } from "../../../../theme/Component/BasicTable"
import { useEffect, useState } from "react";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { SelectProductVariant } from "../../../../Inventories-Warehouses/Product/ProductVariant/SelectProductVariant";
import usePaginator from "../../../../theme/Component/usePaginator";

interface componentData {
    QualityInspectionLote: any
}

export const QualityInspectionLoteItem = ({ QualityInspectionLote }: componentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityInspectionLoteItem);
    const paginator = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Inspección", MODAL_SM);

    const head = [
        { title: 'ID', property: 'IDQualityInspectionLoteItem', visible: true },
        { title: 'Serial del Uniforme', property: 'SerialNumber', visible: true },
        { title: 'Talla', property: 'VariantName', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: false, mask: MASK_DATE },
        { title: 'Empleado', property: 'UserEntity', visible: false },
    ];

    useEffect(() => {
        if (QualityInspectionLote?.IDQualityInspectionLote) {
            getLista();
        }
    }, [QualityInspectionLote?.IDQualityInspectionLote, paginator.page])

    const getLista = () => {
        const props = {
            IDQualityInspectionLote: QualityInspectionLote?.IDQualityInspectionLote,
            State: 1
        }
        instance.getQualityInspectionLoteItemRender(paginator.page, 15, props).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach((element) => {
                    const d = element.DataBeanProperties;
                    d.UserEntity = d.IDEmployee ? `${d.EmployeeNit} - ${d.EmployeeFullName}` : "N/A";
                })
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDQualityInspectionLote: QualityInspectionLote?.IDQualityInspectionLote,
        });
        modal.open("Agregar Uniforme");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Uniforme") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionLoteItem(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = [
            "Size", "SerialNumber"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    pageTop={paginator.page}
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('SerialNumber') ? 'has-error' : ''}`} >Numero de serial</label>
                            <input type="number" value={bean.SerialNumber} onChange={(e) => {
                                const value = e.target.value ? Number(e.target.value) : null;
                                setBean({ ...bean, SerialNumber: value })
                            }} className="form-control" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Size') ? 'has-error' : ''}`} >Talla/Variante del Producto</label>
                            <SelectProductVariant idProduct={QualityInspectionLote.IDProduct} idSelector={bean.Size} onChange={(e) => { setBean({ ...bean, Size: e }) }} label=" " />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}